module.exports = __webpack_public_path__ + "img/LVL.2439c734.svg";